/* eslint-disable */
class ItalianDictionary{
    constructor()
    {
        this.currentLanguage = 'it-it';
        this.dictionary = {
            
        }
    }

}

export default ItalianDictionary;


// WEBPACK FOOTER //
// ./src/localization/it-it.js